module.exports = __webpack_public_path__ + "img/sx.d019f7a5.svg";